module.exports = __webpack_public_path__ + "static/media/Icon-DropDown.43297895.svg";